import axios from "axios";
import { searchApi } from "../../api/searchApi";

// Heroku returns 503 on H12 (30s timeout) and the gateway returns 504. Also
// catch network-level timeouts (ECONNABORTED) and dropped connections.
export const isSearchTimeoutError = (error) => {
  const status = error?.response?.status;
  const code = error?.code;
  return status === 503 || status === 504 || code === "ECONNABORTED" || code === "ERR_NETWORK";
};

/**
 * Stopgap for #560: the first search against a cold catalog can time out while
 * the identical request succeeds warm seconds later, so a timed-out search is
 * retried exactly once before the caller surfaces the error. Never retries a
 * cancelled request, a request whose signal is already aborted (a newer search
 * owns the results), or any non-timeout failure such as a 4xx.
 */
export async function searchWithTimeoutRetry(spec, { signal, onRetry } = {}) {
  try {
    return await searchApi(spec, { signal });
  } catch (error) {
    if (signal?.aborted || axios.isCancel(error) || !isSearchTimeoutError(error)) {
      throw error;
    }
    if (onRetry) onRetry();
    return searchApi(spec, { signal });
  }
}
